var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.233 30.1982C94.2323 28.5441 93.8786 27.0824 93.1631 25.8279C92.4604 24.5943 91.408 23.5604 89.9963 22.7429C78.3436 16.0239 66.6795 9.3254 55.0306 2.59953C51.8901 0.786465 48.8452 0.852563 45.728 2.69165C41.0898 5.427 17.8683 18.7311 10.9486 22.7391C8.09885 24.3888 6.71217 26.9135 6.71148 30.1951C6.70703 43.7075 6.71148 57.2195 6.70703 70.7322C6.70772 72.35 7.04642 73.7833 7.73035 75.019C8.43345 76.2899 9.5006 77.3522 10.9448 78.1882C17.8649 82.1962 41.0895 95.4993 45.7266 98.2353C48.8452 100.075 51.8901 100.141 55.0316 98.3275C66.6809 91.6013 78.3456 84.9031 90 78.1841C91.4443 77.3485 92.5114 76.2854 93.2145 75.0155C93.8974 73.7799 94.2368 72.3466 94.2375 70.7284C94.2375 70.7284 94.2375 43.7109 94.233 30.1982",
    fill: "#5C8DBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6062 50.332L7.73035 75.019C8.43345 76.2899 9.5006 77.3523 10.9448 78.1883C17.8649 82.1963 41.0895 95.4994 45.7266 98.2354C48.8452 100.076 51.8901 100.141 55.0316 98.3275C66.6809 91.6013 78.3456 84.9032 90 78.1842C91.4443 77.3485 92.5114 76.2855 93.2145 75.0156L50.6062 50.332",
    fill: "#1A4674"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9068 57.6446C40.4018 62.0002 45.092 64.9379 50.4723 64.9379C55.8858 64.9379 60.6027 61.9628 63.0849 57.5607L50.6062 50.332L37.9068 57.6446",
    fill: "#1A4674"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.233 30.198C94.2324 28.5438 93.8786 27.0821 93.1631 25.8276L50.6062 50.3317L93.2145 75.0153C93.8974 73.7796 94.2368 72.3464 94.2375 70.7282C94.2375 70.7282 94.2375 43.7107 94.233 30.198",
    fill: "#1B598E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0849 57.5603C60.6027 61.9625 55.8858 64.9376 50.4723 64.9376C45.092 64.9376 40.4018 61.9998 37.9069 57.6442C36.6948 55.5277 35.9979 53.0773 35.9979 50.4632C35.9979 42.4695 42.4786 35.9892 50.4723 35.9892C55.818 35.9892 60.4835 38.8903 62.9908 43.2014L75.6421 35.9163C70.6136 27.2359 61.2253 21.396 50.4723 21.396C34.4184 21.396 21.4047 34.41 21.4047 50.4632C21.4047 55.7298 22.8058 60.6686 25.2545 64.9287C30.2703 73.6549 39.6853 79.5308 50.4723 79.5308C61.2791 79.5308 70.7088 73.6313 75.7175 64.8794L63.0849 57.5603",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.38c84eeaadc56f73c4a79954b522f63f.svg";
export { ForwardRef as ReactComponent };